import { render, staticRenderFns } from "./signInHistory.vue?vue&type=template&id=97766d70&"
import script from "./signInHistory.vue?vue&type=script&lang=js&"
export * from "./signInHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports